/*
  Code-generated abstract geometric composition inspired by IBM's design
  language: a precise grid of square tiles. Most tiles are white / gray-10,
  a few are filled blue-60 / blue-10, and two are split diagonally into
  triangles. Flat, no shadows, no imagery.
*/
const TILES = [
  "gray", "blue", "white", "blue10",
  "white", "split-blue-white", "gray", "blue",
  "blue10", "gray", "split-white-blue10", "white",
  "blue", "white", "blue10", "gray",
];

export default function HeroTiles() {
  return (
    <div className="hero-tiles" aria-hidden="true" data-testid="hero-visual">
      {TILES.map((type, i) => (
        <div key={i} className={`hero-tile hero-tile--${type}`} />
      ))}
    </div>
  );
}
